import React from "react";
import PersonsList from "./Listing/List";
import { Route } from "react-router-dom";
import {
  defaultDecorateSettings,
  defaultDataProfileValidation
} from "components/jarvisly-layouts/ModuleComponent/module-methods";
import {
  PersonsDocumentHeaderColumn2,
  PersonsDocumentHeaderColumn3,
  PersonsDocumentSubtitle
} from "./Form/Header";
import { FormOutlined } from "@ant-design/icons";
import PersonsProfile from "./Form/sections/Profile";

// GLOBAL VARIABLES ************************************************************
// *****************************************************************************

// ************************************************************************** //
// CONSTANTS
// ************************************************************************** //

const PERSONS_URL = "/app/records/entities/customers-persons";
export const PERSONS_API_URL = "/v2/entities";

const INITIAL_LIST_STATE = {
  showNumberOfLine: localStorage.getItem("showNumberOfLine") === "true",
  showCheckBox: localStorage.getItem("showCheckBox") === "true"
};
const INITIAL_REQUEST = {

  // textSearch: {
  //   default: 'mONTE aLto',
  //   enum: ['a', 'b'],
  // },

  folder: {
    default: "documents",
    enum: ["documents", "recycle", "filed"]
  },

  filter: {
    default: {
      dataProfile: ["customer"],
      dataType: ["person"]
    },
    enum: {
      dataProfile: ["customer"],
      dataType: ["person"]
    }
  },

  // filter: {
  //   default: {
  //     color: { $in: ['black', 'white'] },
  //     city: { $in: ['Campinas'] },
  //   },
  //   enum: {
  //     color: ['branco', 'azul', 'amarelo'],
  //     city: ['Campinas', 'Itu'],
  //   },
  // },

  search: {},
  //   default: {
  //     age: 43,
  //     roomNumber: { $in: [11, 12, 43] },
  //     name: 'Ane Cardinalli',
  //   },
  //   enum: {
  //     age: [10, 30, 40],
  //     roomNumber: [22, 33, 54, 82],
  //   },
  // },

  sorter: {
    // roomNumber: 1,
    // blockId:-1
  },

  // project: {
  //   room: 1,
  //   blockId: 1,
  // },

  pagination: {
    pageNumber: 1,
    // pageSize: 10
    pageSize: ["10", "20", "50", "100"].includes(localStorage.getItem("pageSize"))
      ? Number(localStorage.getItem("pageSize"))
      : 10
  }
};
/*

const INITIAL_FILTER = {
  folder: 'documents',
  // dataProfile: 'plan',
}

const INITIAL_SORT = {
  sortField: '_metadata.audit.updatedAt',
  sortOrder: 'descend',
}

const INITIAL_SEARCH = {
  roomNumber: 'null',
  blockId: 'null',
  documentStatus: 'null',
}
*/

const INITIAL_CONTEXT = {
  hasPicture: false,
  mode: "nope",

  selectedSection: null,
  sectionsChanged: [],
  sectionSettingsComponent: null
};

const METHODS = {
  // parseSettings: parseSettings,
  decorateSettings: defaultDecorateSettings,

  // decorateDocument: decorateDocument,
  // decorateNewDocument: decorateNewDocument,

  // removeDocumentValidation: removeDocumentValidation,
  postDocumentValidation: defaultDataProfileValidation,
  putDocumentValidation: defaultDataProfileValidation

  // refreshParameters: getPersonModuleParameters,
};

const COMPONENTS = {
  list: props => <PersonsList {...props} />,
  // listPreviewHeader: props => <PersonsBodyPreviewHeader {...props}/>,
  // listPreviewBody: props => <PersonsBodyPreviewData {...props}/>,
  // listPreviewActions: props => <PersonsBodyPreviewActions {...props}/>,

  documentSubtitle: props => <PersonsDocumentSubtitle {...props} />,
  // documentSubtitle: props => <div>{props?.record?.description}</div>,
  documentHeaderColumn2: props => <PersonsDocumentHeaderColumn2 {...props} />,
  documentHeaderColumn3: props => <PersonsDocumentHeaderColumn3 {...props} />

  // moduleSettings: props => <personsSettingsTabs {...props}/>,
  // moduleSettings: personsSettingsTabs(),
};

const DATA_TYPES = [
  {
    key: "person",
    label: "individual_person",
    description: "entities_individual_person_description",
    checked: true
  }
];

const DOCUMENT_SECTIONS = [
  {
    key: "profile",
    icon: <FormOutlined />,
    label: "registration_data",
    route: (props, ref, _id) => <Route key="profile"
                                       path={`${PERSONS_URL}/${_id}/profile`}
                                       render={() =>
                                         <PersonsProfile ref={ref} {...props}
                                                         _data={props._dataRoots}
                                                         _dataLock={props._dataRootsLock} />} />
  }
  /*  {
      key: 'fiscal',
      icon: <FundOutlined/>,
      label: 'fiscal',
      route: (props, ref, _id) => <Route key="fiscal"
                                         path={`${PERSONS_URL}/${_id}/fiscal`}
                                         render={() =>
                                           <NoSection ref={ref} {...props}
                                                      _data={props._data?.titular}
                                                      _dataLock={props._dataLock?.titular}/>}/>,
    },*/
  /*  {
      key: 'banks',
      icon: <BankOutlined/>,
      label: 'banks',
      route: (props, ref, _id) => <Route key="banks"
                                         path={`${PERSONS_URL}/${_id}/banks`}
                                         render={() =>
                                           <NoSection ref={ref} {...props} />}/>,
    },*/
];

const REQUIRED_FIELDS = [

  {
    key: "cpf",
    label: "cpf",
    checked: true,
    disabled: false,
    forDataType: ["person"]
  },

  {
    key: "birthday",
    label: "birthdate",
    checked: false,
    disabled: false,
    forDataType: ["person"]
  },
  {
    key: "name",
    label: "name",
    checked: true,
    disabled: true,
    forDataType: ["person"]
  },

  {
    key: "phone",
    label: "phone",
    checked: true,
    disabled: false,
    dependence: "email",
    dependence_msg: "",
    forDataType: ["person"]
  },

  {
    key: "email",
    label: "email",
    checked: false,
    disabled: false,
    dependence: "phone",
    forDataType: ["person"]
  }

];

// ************************************************************************** //
// SEEDS
// ************************************************************************** //

const SETTINGS_SEED = {

  configurations: {
    dataTypes: ["person"]
  },

  requiredFields: [
    "cpf",
    "rg",
    "name",
    "mainPhone"
  ]
};

const DATA_AUTO_FILL = {
  // _id: '6450498ff324dea15b193702',
  _metadata: {
    subscriptionId: "643ec14175fdf864855d7183",
    documentStatus: 0,
    hidden: false,
    system: false,
    audit: {
      createdByAccountId: "64390f9545f33710d79ba062",
      createdOnClient: {
        userAgent: "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/112.0.0.0 Safari/537.36",
        acceptLanguage: "en-US,en;q=0.9,pt;q=0.8"
      },
      createdAt: "2023-05-01T23:21:51.826Z",
      updatedAt: "2023-05-01T23:21:51.826Z"
    },
    i18n: {
      countryCode: "br",
      timezoneOffset: -180,
      languageCode: "pt-br",
      localeCode: "br"
    },
    documentCode: "193702",
    origin: 0,
    counter: 1,
    __documentCode: "1.193702",
    __documentStatus: "in_analise"
  },
  uniqueKey: "02934311000153",
  dataProfile: ["customer"],
  dataType: "person",
  name: "Rick Biruel",
  fullName: "Rick Biruel",
  backColor: "#b9bcc4",
  foreColor: "#ffffff",
  cpf: "60034521020",
  phone: "11996060000",
  email: "contato@infodesk.com.br",
  website: "www.infodesk.com.br",
  zip: "13010-111",
  address1: "Rua General Osório",
  number: "1200",
  neighborhood: "Centro",
  city: "Campinas",
  province: "SP",
  addressMetadata: {
    countryCode: "br",
    foundByApi: true,
    apiUrl: "https://viacep.com.br/ws/13010111/json/",
    zipWithMultipleAddress: false
  },
  addressAdditionalInfo: {
    note: "de 762/763 a 1661/1662",
    areaCode: "19",
    giaCode: "2446",
    ibgeCode: "3509502",
    siafiCode: "6291"
  },
  addressGps: [-22.9034349, -47.058309],
  __v: 0,
  __city: "Campinas - SP"
};

// ************************************************************************** //
// MODULES PARAMETERS
// ************************************************************************** //

export const MODULE_PERSONS_PARAMETERS = {

  root: "persons",
  name: "persons",
  singular: "person",
  titleField: "name",
  url: PERSONS_URL,
  api: PERSONS_API_URL,
  initialRequest: INITIAL_REQUEST,
  initialListState: INITIAL_LIST_STATE,

  hasDashboard: true,
  hasFilter: true,
  hasSettings: true,
  hasAccessControl: true,
  hasConfigurations: true,
  hasDataMemory: true,
  hasRequiredFields: false,

  documentActions: {
    archive: false,
    duplicate: false
  },

  // showNumberOfLine: true,

  methods: METHODS,
  components: COMPONENTS,
  dataTypes: DATA_TYPES,
  requiredFields: REQUIRED_FIELDS,

  initialContext: INITIAL_CONTEXT,

  // initialSearch: INITIAL_SEARCH,

  // initialFilter: INITIAL_FILTER,
  // initialSort: INITIAL_SORT,

  labels: {
    new_document_title: "new_customer"
  },

  documentSections: DOCUMENT_SECTIONS,

  seeds: {
    settings: SETTINGS_SEED,
    data: DATA_AUTO_FILL
  }

};


